import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { sortSearchParam } from '@/components/data-table/tableSort';
import { ArchivedPage } from '@/features/settings/ui/ArchivedPage';

export const Route = createFileRoute('/_authenticated/archive/projects')({ validateSearch: z.object({ s: sortSearchParam }), component: ArchivedPage });
